"use client";
import React from "react";
import { Modal, Divider, Segment, Grid, Icon, Loader } from "semantic-ui-react";
import { Title, InText } from "../../components";
import { styles } from "./element";
import * as yup from "yup";
import Router from "next/router";
import { Button, Form, Input } from "formik-semantic-ui";

const LoginModal = ({
  open,
  submit,
  next,
  iconclick,
  pwd_err_status,
  pwd_err_msg,
  email_err_status,
  email_err_msg,
  onChangeCheckbox,
  isChecked,
  passval,
  emailval,
  user_confirm_status,
  isSaving,
}) => {
  // const validations = yup.object().shape({
  // 	email: yup
  // 		.string()
  // 		.email("Invalid Email")
  // 		.required("Email is required"),
  // 	// password: yup.string().required("Password is Required")
  // });
  return (
    <Modal open={open} size="tiny" style={styles} centered>
      <Segment padded>
        <Grid>
          <Grid.Row>
            <Grid.Column width={13}>
              <Title floated="left" content="Sign In" size="large" />
            </Grid.Column>
            <Grid.Column
              verticalAlign="middle"
              width={3}
              style={{ textAlign: "right" }}
            >
              <span onClick={iconclick}>
                <Icon link size="large" name="close" />
              </span>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        <Modal.Content>
          <Form
            initialValues={{
              email: emailval,
              password: passval,
              id: "lmodal",
            }}
            onSubmit={(values, formikApi) => submit(values, formikApi)}
            ignoreLoading={true}
            // validationSchema={validations}
          >
            <Input
              name="email"
              inputProps={{
                placeholder: "Email",
              }}
            />
            {email_err_status ? (
              <span className="sui-error-message">{email_err_msg}</span>
            ) : null}
            <Input
              name="password"
              inputProps={{
                type: "password",
                placeholder: "Password",
              }}
            />
            {pwd_err_status ? (
              <span className="sui-error-message">{pwd_err_msg}</span>
            ) : null}
            {user_confirm_status ? (
              <span className="sui-error-message">
                User is not confirmed. Please check your email for verification.
                Can't find it?{" "}
                <a onClick={() => Router.push("/login")}>Click here.</a>
              </span>
            ) : null}

            <span style={{ cursor: "pointer" }} onClick={(e) => next(e)}>
              <InText
                content="Forgot Password"
                floated="left"
                color="blue"
                id="fmodal"
              />
            </span>
            <div className="remember_chk">
              <input
                type="checkbox"
                checked={isChecked || false}
                name="lsRememberMe"
                onChange={(e) => onChangeCheckbox(e)}
              />
              &nbsp;
              <label>Remember Me</label>
            </div>
            <Divider hidden />
            <Button.Submit fluid primary disabled={isSaving}>
              {isSaving && <Loader active inline size="tiny" />} Sign In
            </Button.Submit>
          </Form>
          <Divider hidden />
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => (next ? next(e) : Router.push("/signup"))}
          >
            {/* <Title
							id="lmodal"
							content="New?"
							//icon="long arrow alternate left"
						/> */}
            New? <a>Sign Up</a>
          </span>
          <Divider hidden />
          {/* <InText content="By joining you agree to RYLY's Terms of Use and Privacy Policy" /> */}
        </Modal.Content>
      </Segment>
    </Modal>
  );
};

export default LoginModal;
